import React from 'react';

function CompetitionPlayerEmailPanel({ compEmailMode, compGeneralSendMode, compGeneralTemplateId, compQuickEmailBody, compQuickEmailSubject, hasEntryConfirmationTemplate, isAdmin, manualCompEmailTemplates, selectedCompPlayerIds, sendCompetitionEmail, sendingCompEmail, setCompEmailMode, setCompGeneralSendMode, setCompGeneralTemplateId, setCompQuickEmailBody, setCompQuickEmailSubject }) {
  if (!(isAdmin && selectedCompPlayerIds.length > 0)) return null;
  return (
      <div className="w3-panel w3-pale-green w3-round" style={{ marginTop: '14px', padding: '10px 12px' }}>
        <strong className="w3-small"><i className="fa fa-paper-plane w3-margin-right"></i>Email Selected Players</strong>
        <div style={{ display: 'flex', gap: '16px', marginTop: '8px', flexWrap: 'wrap' }}>
          <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
            <input
              type="radio"
              className="w3-radio"
              name="compEmailMode"
              checked={compEmailMode === 'general'}
              onChange={() => setCompEmailMode('general')}
            />
            General Email
          </label>
          <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
            <input
              type="radio"
              className="w3-radio"
              name="compEmailMode"
              checked={compEmailMode === 'entry-confirmation'}
              onChange={() => setCompEmailMode('entry-confirmation')}
            />
            Competition Entry Confirmation
          </label>
        </div>

        {compEmailMode === 'general' ? (
          <div style={{ marginTop: '8px' }}>
            <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '8px' }}>
              <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  className="w3-radio"
                  name="compGeneralSendMode"
                  checked={compGeneralSendMode === 'template'}
                  onChange={() => setCompGeneralSendMode('template')}
                />
                Use Saved Template
              </label>
              <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  className="w3-radio"
                  name="compGeneralSendMode"
                  checked={compGeneralSendMode === 'quick'}
                  onChange={() => setCompGeneralSendMode('quick')}
                />
                Quick Email
              </label>
            </div>

            {compGeneralSendMode === 'template' ? (
              <>
                <select
                  className="w3-select w3-border w3-round"
                  value={compGeneralTemplateId}
                  onChange={e => setCompGeneralTemplateId(e.target.value)}>
                  <option value="">Select general template...</option>
                  {manualCompEmailTemplates.map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                {manualCompEmailTemplates.length === 0 && (
                  <p className="w3-small w3-text-grey" style={{ marginTop: '6px', marginBottom: 0 }}>
                    No general templates available yet. Create one in the Email Templates tab.
                  </p>
                )}
              </>
            ) : (
              <>
                <input
                  className="w3-input w3-border w3-round"
                  placeholder="Quick email subject"
                  value={compQuickEmailSubject}
                  onChange={e => setCompQuickEmailSubject(e.target.value)}
                  style={{ marginBottom: '8px' }}
                />
                <textarea
                  className="w3-input w3-border w3-round"
                  placeholder="Write your quick email message here..."
                  value={compQuickEmailBody}
                  onChange={e => setCompQuickEmailBody(e.target.value)}
                  style={{ minHeight: '110px', resize: 'vertical' }}
                />
                <p className="w3-small w3-text-grey" style={{ marginTop: '6px', marginBottom: 0 }}>
                  Placeholders supported: {'{{userName}}'}, {'{{clubName}}'}, {'{{competitionName}}'}, {'{{competitionEntryFee}}'}, {'{{competitionEntryFeeDisplay}}'}
                </p>
              </>
            )}
          </div>
        ) : (
          <div className="w3-small" style={{ marginTop: '8px' }}>
            {hasEntryConfirmationTemplate ? (
              <span className="w3-text-grey">Uses your club's registration confirmation template.</span>
            ) : (
              <span className="w3-text-red">Competition entry confirmation template not found.</span>
            )}
          </div>
        )}

        <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span className="w3-small w3-text-grey">
            Sending to {selectedCompPlayerIds.length} selected player{selectedCompPlayerIds.length !== 1 ? 's' : ''}
          </span>
          <button
            className="w3-button w3-theme w3-round"
            disabled={
              sendingCompEmail ||
              selectedCompPlayerIds.length === 0 ||
              (compEmailMode === 'general' && compGeneralSendMode === 'template' && !compGeneralTemplateId) ||
              (compEmailMode === 'general' && compGeneralSendMode === 'quick' && (!compQuickEmailSubject.trim() || !compQuickEmailBody.trim())) ||
              (compEmailMode === 'entry-confirmation' && !hasEntryConfirmationTemplate)
            }
            onClick={sendCompetitionEmail}>
            <i className="fa fa-send w3-margin-right"></i>
            {sendingCompEmail ? 'Sending...' : 'Send Email'}
          </button>
        </div>
      </div>
  );
}

export default CompetitionPlayerEmailPanel;
